import { Label } from '@restore/clinicalTrialContext/clinicalTrialContext.types';
import { DXAWorkstationDataDTO } from '@dynamika-shared/types/DXAReading';

export const filterDXALabels = (
  groupedLabels: Label[],
  visitData: DXAWorkstationDataDTO | null
) => {
  if (visitData?.dxaScores?.length) {
    const dxaScores = new Set(visitData?.dxaScores.map(score => score.labelId));
    return groupedLabels.filter(label => !dxaScores.has(label.id));
  } else {
    return groupedLabels;
  }
};

export const findLabelName = (
  labelId: string,
  labels: Label[]
): string | undefined => {
  return labels.find(label => label.id === labelId)?.name;
};

export const addedLabelsToVisits = (
  visitData: DXAWorkstationDataDTO | null,
  groupedLabels: Label[]
) => {
  if (visitData) {
    const updatedLabels = visitData?.dxaScores?.map(visit => {
      const currentLabelName = visit.labelId
        ? findLabelName(visit.labelId, groupedLabels)
        : '';

      return { ...visit, labelName: currentLabelName };
    });

    return updatedLabels;
  }
};
